import React from 'react';

export const Chat = (props : any) => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={19.276}
        height={18}
        viewBox="0 0 19.276 18"
        {...props}
        >
            <defs>
                <style>{".a{fill:#414141;}"}</style>
            </defs>
            <g transform="translate(-2.134 -3.581)">
                <g transform="translate(2.134 3.581)">
                <path
                    className="a"
                    d="M185.765,249.859a6.052,6.052,0,0,0-2.937,8.222l-.683,2.96a.441.441,0,0,0,.529.529l2.959-.683a6.027,6.027,0,0,0,7.383-1.6c.175.015.314.016.468.023a7.788,7.788,0,0,0,3.473-.839l3.913.9a.441.441,0,0,0,.529-.529l-.9-3.914a7.853,7.853,0,0,0,.839-3.486,8.007,8.007,0,0,0-7.824-7.865,7.7,7.7,0,0,0-7.745,6.278Zm14.687,1.587a6.98,6.98,0,0,1-.806,3.254.441.441,0,0,0-.04.3l.774,3.351-3.351-.774a.441.441,0,0,0-.3.04,6.983,6.983,0,1,1,3.727-6.176Zm-14.821-.528c-.012.175-.027.35-.027.528a7.873,7.873,0,0,0,6.336,7.713,5.209,5.209,0,0,1-6.076.879.441.441,0,0,0-.306-.04l-2.4.554.554-2.4a.441.441,0,0,0-.04-.3,5.229,5.229,0,0,1-.6-2.437A5.116,5.116,0,0,1,185.631,250.919Z"
                    transform="translate(-182.134 -243.582)"
                />
                <path
                    className="a"
                    d="M19.191,15a.441.441,0,0,0,0,.882h4.849a.441.441,0,1,0,0-.882Z"
                    transform="translate(-11.426 -9.967)"
                />
                <path
                    className="a"
                    d="M19.191,21a.441.441,0,1,0,0,.882h7.934a.441.441,0,0,0,0-.882Z"
                    transform="translate(-11.426 -13.322)"
                />
                <path
                    className="a"
                    d="M19.191,27a.441.441,0,1,0,0,.882h4.849a.441.441,0,0,0,0-.882Z"
                    transform="translate(-11.426 -16.678)"
                />
                </g>
            </g>
        </svg>
    )
}

export const Reply = (props : any) => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={19.276}
        height={18}
        viewBox="0 0 19.276 18"
        {...props}
        >
            <defs>
                <style>{".a{fill:#414141;}"}</style>
            </defs>
            <g transform="translate(2984.866 -4698)">
                <g transform="translate(-2984.866 4698)">
                <g transform="translate(0 0)">
                    <path
                    className="a"
                    d="M185.766,249.859a6.052,6.052,0,0,0-2.937,8.222l-.683,2.96a.441.441,0,0,0,.529.529l2.959-.683a6.027,6.027,0,0,0,7.383-1.6c.175.015.314.016.468.023a7.788,7.788,0,0,0,3.473-.839l3.913.9a.441.441,0,0,0,.529-.529l-.9-3.914a7.854,7.854,0,0,0,.839-3.486,8.007,8.007,0,0,0-7.824-7.865A7.7,7.7,0,0,0,185.766,249.859Zm14.687,1.587a6.98,6.98,0,0,1-.806,3.254.441.441,0,0,0-.04.3l.774,3.351-3.351-.774a.441.441,0,0,0-.3.04,6.983,6.983,0,1,1,3.727-6.176Zm-14.821-.528c-.012.175-.027.35-.027.528a7.873,7.873,0,0,0,6.336,7.713,5.21,5.21,0,0,1-6.076.879.441.441,0,0,0-.306-.04l-2.4.554.554-2.4a.441.441,0,0,0-.04-.3,5.229,5.229,0,0,1-.6-2.437A5.116,5.116,0,0,1,185.631,250.919Z"
                    transform="translate(-182.134 -243.582)"
                    />
                </g>
                </g>
                <g transform="translate(-2977.322 4703.29)">
                <path
                    className="a"
                    d="M8.361,6.959H3.266L4.484,5.708A.3.3,0,1,0,4.05,5.3L2.335,7.04a.3.3,0,0,0-.085.219h0a.3.3,0,0,0,.118.232l1.69,1.751A.3.3,0,0,0,4.5,8.836L3.278,7.585H8.356a1.251,1.251,0,0,1,0,2.5H7.719a.3.3,0,1,0,0,.609h.646a1.861,1.861,0,0,0,0-3.718Z"
                    transform="translate(-2.25 -5.152)"
                />
                </g>
            </g>
        </svg>
    )
}

export const Question = (props : any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={19.502}
            height={18}
            viewBox="0 0 19.502 18"
            {...props}
            >
            <defs>
                <style>{".a,.b{fill:#414141;}.b{fill-rule:evenodd;}"}</style>
            </defs>
            <g transform="translate(-1.409)">
                <g transform="translate(0.001)">
                <path
                    className="a"
                    d="M160.82,89.049a3.189,3.189,0,0,1,2.761-1.539,3.042,3.042,0,0,1,3.137,2.928,2.954,2.954,0,0,1-2.1,2.764.752.752,0,0,0-.53.725l0,.978h-1.015l0-.978a1.769,1.769,0,0,1,1.231-1.693,1.933,1.933,0,0,0,1.4-1.8,2.024,2.024,0,0,0-2.118-1.909,2.147,2.147,0,0,0-1.88,1.03Z"
                    transform="translate(-153.222 -83.375)"
                />
                <path
                    className="b"
                    d="M202.945,259.43a.8.8,0,1,1-.8.8A.8.8,0,0,1,202.945,259.43Z"
                    transform="translate(-192.59 -247.173)"
                />
                <path
                    className="a"
                    d="M9,0a9,9,0,1,0,5.314,16.262l4.615.7a.5.5,0,0,0,.52-.72L17.507,11.94A9,9,0,0,0,9,0ZM9,1a8.01,8.01,0,0,1,7.511,10.767.5.5,0,0,0,0,.4l1.656,3.671-3.912-.6a.5.5,0,0,0-.379.1A8,8,0,1,1,9,1Z"
                    transform="translate(1.406)"
                />
                </g>
            </g>
        </svg>
    )
}